<template>
  <v-calendar
    :formats='calendarFormats'
    :attributes='calendarAttrs'
    :from-page="{month: computedMonth, year: computedYear}"
  />
</template>

<script>
  export default {
    name: "ScheduleRecurringExpenseCalendar",
    data() {
      return {
        computedMonth: new Date().getMonth() + 1,
        computedYear: new Date().getFullYear(),
        calendarAttrs: [
        {
          highlight: {
          },
          contentStyle: {
            color: "black",
            fontSize: "12px",
            fontWeight: "bold"
          },
          dates: [
            new Date()
          ]
        },
        {
          highlight: {
            backgroundColor: "#1554E4", // Scheduled dates
            borderColor: "#1554E4",
            borderWidth: "1px",
            opacity: "1"
          },
          contentStyle: {
            color: "white",
            fontSize: "12px",
            fontWeight: "bold"
          },
          dates: [],
        }
      ],
      calendarFormats: {
        title: "MMM YYYY"
      },
      };
    },
    methods: {
      dateUTC(date) {
        date = new Date(date);
        // date.setTime(date.getTime() + Math.abs(date.getTimezoneOffset()) * 60000);
        return date;
      },
      drawCalendar(paymentDate, endDate, endUnit, intervalUnit, intervalDuration, endDuration) {
        this.calendarAttrs[1].dates = [];
        this.calendarAttrs[1].dates.push(paymentDate);
        this.computedMonth = new Date(paymentDate).getMonth() + 1;
        this.computedYear = new Date(paymentDate).getFullYear();
        if (endUnit === 'on') {
          this.drawCalendarOn(paymentDate, endDate, intervalUnit, intervalDuration)
        } else if (endUnit === 'after') {
          this.drawCalendarAfter(paymentDate, intervalUnit, intervalDuration, endDuration)
        } else if (endUnit === 'never') {
          this.drawCalendarNever(paymentDate, intervalUnit, intervalDuration)
        }
        this.$emit("setCalendarAttrs", this.calendarAttrs);
      },
      drawCalendarOn(paymentDate, endDate, intervalUnit,intervalDuration) {
        let dateIterator = this.dateUTC(this.clone(paymentDate));
        endDate = this.dateUTC(endDate);
        if (intervalUnit) {
            while (dateIterator.getTime() <= endDate.getTime()) {
                if (intervalUnit === 'day') {
                    let innerDate = this.clone(dateIterator);
                    innerDate = this.getNextDate(dateIterator, parseInt(intervalDuration));
                    innerDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    if (innerDate.getTime() <= endDate.getTime()) {
                        this.calendarAttrs[1].dates.push(innerDate);
                    }
                    dateIterator = this.clone(innerDate)
                } else if (intervalUnit === 'week') {
                    let weekInnerDate = this.clone(dateIterator);
                    weekInnerDate = this.getNextDate(dateIterator, parseInt(intervalDuration) * 7);
                    weekInnerDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    if (weekInnerDate.getTime() <= endDate.getTime()) {
                        this.calendarAttrs[1].dates.push(weekInnerDate);
                    }
                    dateIterator = this.clone(weekInnerDate)
                } else if (intervalUnit === 'month') {
                    let monthInnerDate = this.clone(dateIterator);
                    monthInnerDate = this.getNextDateWhenMonth(dateIterator, parseInt(intervalDuration));
                    monthInnerDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    if (monthInnerDate.getTime() <= endDate.getTime()) {
                        this.calendarAttrs[1].dates.push(monthInnerDate);
                    }
                    dateIterator = this.clone(monthInnerDate)
                } else if (intervalUnit === 'year') {
                    let yearInnerDate = this.clone(dateIterator);
                    yearInnerDate = this.getNextDateWhenYear(dateIterator, parseInt(intervalDuration));
                    yearInnerDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    if (yearInnerDate.getTime() <= endDate.getTime()) {
                        this.calendarAttrs[1].dates.push(yearInnerDate);
                    }
                    dateIterator = this.clone(yearInnerDate)
                }
            }
        }
      },
      drawCalendarAfter(paymentDate, intervalUnit, intervalDuration, endDuration) {
        if (intervalUnit === 'day') {
          let dateIterator = this.clone(paymentDate);
          for (let i = 0; i < Math.min(endDuration - 1, 100); i++) {
            let innerDate = this.clone(dateIterator);
            innerDate = this.getNextDate(dateIterator, parseInt(intervalDuration));
            this.calendarAttrs[1].dates.push(innerDate);
            dateIterator = this.clone(innerDate)
          }
        } else if (intervalUnit === 'week') {
          let weekDateIterator = this.clone(paymentDate);
          for (let i = 0; i < Math.min(endDuration - 1, 100); i++) {
            let weekInnerDate = this.clone(weekDateIterator);
            weekInnerDate = this.getNextDate(weekDateIterator, parseInt(intervalDuration) * 7);
            this.calendarAttrs[1].dates.push(weekInnerDate);
            weekDateIterator = this.clone(weekInnerDate)
          }
        } else if (intervalUnit === 'month') {
          let monthDateIterator = this.clone(paymentDate);
          for (let i = 0; i < Math.min(endDuration - 1, 100); i++) {
            let monthInnerDate = this.clone(monthDateIterator);
            monthInnerDate = this.getNextDateWhenMonth(monthDateIterator, parseInt(intervalDuration));
            this.calendarAttrs[1].dates.push(monthInnerDate);
            monthDateIterator = this.clone(monthInnerDate)
          }
        } else if (intervalUnit === 'year') {
          let yearDateIterator = this.clone(paymentDate);
          for (let i = 0; i < Math.min(endDuration - 1, 100); i++) {
            let yearInnerDate = this.clone(yearDateIterator);
            yearInnerDate = this.getNextDateWhenYear(yearDateIterator, parseInt(intervalDuration));
            this.calendarAttrs[1].dates.push(yearInnerDate);
            yearDateIterator = this.clone(yearInnerDate)
          }
        }
      },
      drawCalendarNever(paymentDate, intervalUnit, intervalDuration) {
        let endDuration = 366;
        let endDate = this.clone(paymentDate);
        endDate.setFullYear(endDate.getFullYear() + 1);
        if (intervalUnit === 'day') {
          let dateIterator = this.clone(paymentDate);
          for (let i = 0; i < endDuration - 1; i++) {
            let innerDate = this.clone(dateIterator);
            innerDate = this.getNextDate(dateIterator, parseInt(intervalDuration));
            if (innerDate <= endDate) {
              this.calendarAttrs[1].dates.push(innerDate);
            }
            dateIterator = this.clone(innerDate)
          }
        } else if (intervalUnit === 'week') {
          let weekDateIterator = this.clone(paymentDate);
          for (let i = 0; i < endDuration - 1; i++) {
            let weekInnerDate = this.clone(weekDateIterator);
            weekInnerDate = this.getNextDate(weekDateIterator, parseInt(intervalDuration) * 7);
            if (weekInnerDate <= endDate) {
              this.calendarAttrs[1].dates.push(weekInnerDate);
            }
            weekDateIterator = this.clone(weekInnerDate)
          }
        } else if (intervalUnit === 'month') {
          let monthDateIterator = this.clone(paymentDate);
          for (let i = 0; i < endDuration - 1; i++) {
            let monthInnerDate = this.clone(monthDateIterator);
            monthInnerDate = this.getNextDateWhenMonth(monthDateIterator, parseInt(intervalDuration));
            if (monthInnerDate <= endDate) {
              this.calendarAttrs[1].dates.push(monthInnerDate);
            }
            monthDateIterator = this.clone(monthInnerDate)
          }
        } else if (intervalUnit === 'year') {
          let yearDateIterator = this.clone(paymentDate);
          for (let i = 0; i < endDuration - 1; i++) {
            let yearInnerDate = this.clone(yearDateIterator);
            yearInnerDate = this.getNextDateWhenYear(yearDateIterator, parseInt(intervalDuration));
            if (yearInnerDate <= endDate) {
              this.calendarAttrs[1].dates.push(yearInnerDate);
            }
            yearDateIterator = this.clone(yearInnerDate)
          }
        }
      },
      getNextDate(date, move) {
        date = this.dateUTC(date);
        return this.dateUTC(date.setDate(date.getDate() + move));
      },
      getNextDateWhenMonth(date, move) {
        return this.$parent.addMonths(date, move)
      },
      getNextDateWhenYear(date, move) {
        return this.$parent.addYears(date, move)
      },
      clone(obj) {
        let copy;

        if (typeof obj === 'string') {
            copy = new Date();
            copy.setTime(new Date(obj).getTime());
            return copy;
        }

        if (null == obj || "object" != typeof obj) return obj;

        if (obj instanceof Date) {
          copy = new Date();
          copy.setTime(obj.getTime());
          return copy;
        }
    
        if (obj instanceof Array) {
          copy = [];
          for (let i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
          }
          return copy;
        }
    
        if (obj instanceof Object) {
          copy = {};
          for (let attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
          }
          return copy;
        }
      },
    }
  };
</script>

